(() => {
  /* ========= SETTINGS ========= */
  const DEFAULT_THRESHOLD_CENTS = 30000; // $300
  const ADDON_PROP_KEY = '_builder_addon';
  const MATCH_TEXTS = ['setup fee', 'logo setup', 'digitizing', 'artwork'];
  const USE_TOTAL_PRICE = false; // false = items_subtotal_price

  /* ========= INTERNAL STATE ========= */
  let running = false;
  let lastStateKey = '';

  /* ========= HELPERS ========= */
  const cartFetch = async () => {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  };

  const changeLineByKey = async (key, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('change.js failed');
    return res.json();
  };

  const isSetupFeeItem = (item) => {
    if (!item || !item.properties) return false;
    const v = (item.properties[ADDON_PROP_KEY] || '').toString().toLowerCase();
    return MATCH_TEXTS.some(t => v.includes(t));
  };

  const getThresholdCents = () => {
    const el = document.querySelector('#blank-builder');
    const raw = el && el.dataset ? el.dataset.setupFeeThreshold : null;
    if (raw == null || raw === '') return DEFAULT_THRESHOLD_CENTS;
    const dollars = Number(raw);
    if (!Number.isFinite(dollars)) return DEFAULT_THRESHOLD_CENTS;
    return Math.round(dollars * 100);
  };

  const getCartTotal = (cart) => {
    if (!cart) return 0;
    return USE_TOTAL_PRICE
      ? cart.total_price || 0
      : (cart.items_subtotal_price ?? cart.total_price ?? 0);
  };

  /* ========= CORE ========= */
  const run = async (reason = 'unknown') => {
    if (running) return;
    running = true;

    try {
      const cart = await cartFetch();

      const feeItems = cart.items.filter(isSetupFeeItem);
      const feeSum = feeItems.reduce(
        (s, i) => s + (i.final_line_price || i.line_price || 0),
        0
      );

      const total = getCartTotal(cart);
      const baseTotal = Math.max(0, total - feeSum);

      const thresholdCents = getThresholdCents();
      const shouldHaveFee = baseTotal < thresholdCents;
      const hasFee = feeItems.length > 0;

      const stateKey = `${shouldHaveFee}-${hasFee}-${feeItems.length}`;
      if (stateKey === lastStateKey) return;
      lastStateKey = stateKey;

      // ❌ Fee есть, но больше не нужен → удалить
      if (!shouldHaveFee && hasFee) {
        for (const item of feeItems) {
          await changeLineByKey(item.key, 0);
        }

        // обновляем UI корзины
        const cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.refresh === 'function') {
          cartItems.refresh();
        }
      }

    } catch (e) {
      console.warn('[setup-fee]', e);
    } finally {
      running = false;
    }
  };

  /* ========= TRIGGERS ========= */

  // 1) при загрузке
  document.addEventListener('DOMContentLoaded', () => run('dom'));

  // 2) при любом изменении line item (самое важное)
  document.addEventListener('on:line-item:change', () => {
    setTimeout(() => run('line-change'), 100);
  });

  // 3) при AJAX-перерисовке корзины
  const cartItems = document.querySelector('cart-items');
  if (cartItems) {
    const mo = new MutationObserver(() => {
      run('mutation');
    });
    mo.observe(cartItems, { childList: true, subtree: true });
  }
})();
